import moment from 'moment';
import { Col, Row, Typography } from 'antd';
import UserAvatar from 'components/new-ui/base/avatar/UserAvatar';
import { H3 } from 'components/new-ui/base/typography/styles';
import { ManifestHistory } from 'store/manifests/types';

type Props = {
    title?: string;
    content?: string;
    createdAt?: string;
    createdBy?: ManifestHistory['creator'];
};

const HistoryItem = ({ title = '', content = '', createdAt = '', createdBy }: Props) => {
    const formattedDate = createdAt && moment(createdAt).format('DD/MM/YYYY, hh:mm:ss A');

    const finalCreatedBy = (() => {
        if (!createdBy) {
            return undefined;
        }

        if (typeof createdBy === 'string') {
            return {
                id: createdBy,
                avatarImageUrl: '',
                name: createdBy,
            };
        } else if ('fullName' in createdBy) {
            return {
                id: createdBy.id,
                avatarImageUrl: createdBy.profilePictureLink,
                name: createdBy.fullName,
            };
        }

        return undefined;
    })();

    return (
        <Row gutter={24} justify="space-between">
            <Col
                lg={16}
                md={24}
                style={{
                    maxWidth: '75ch',
                    marginBottom: 16,
                }}
            >
                <H3>{title}</H3>
                <Typography.Text>{content}</Typography.Text>
            </Col>
            <Col lg={8} md={24}>
                <Row gutter={8} align="middle" justify="space-between">
                    <Col>
                        <UserAvatar
                            style={{ marginRight: 4 }}
                            src={finalCreatedBy?.avatarImageUrl}
                            userName={finalCreatedBy?.name}
                        />
                        <span>{finalCreatedBy?.name ?? ''}</span>
                    </Col>
                    <Col>{formattedDate}</Col>
                </Row>
            </Col>
        </Row>
    );
};

export default HistoryItem;
